import ImageCustom from '@/components/Image'
import { BrandingType } from '@/libs/types'
import Link from 'next/link'
import React from 'react'

interface BrandingProps {
    brand: BrandingType
    locale: string
}

const Branding: React.FC<BrandingProps> = ({ brand, locale }) => {
    return !!brand ? (
        <Link href={`/${locale}/`} passHref className='my-auto'>
            <div className="cursor-pointer my-auto" style={{ lineHeight: 0 }}>
                <ImageCustom src={brand.logo || ''} alt="Logo" width={brand.width || 0} height={brand.height || 0} />
            </div>
        </Link>
    ) : (
        <div className="brand fw-bold my-auto">
            branding.
        </div>
    )
}

export default Branding